import { ContextData, metrics } from '@prophecy/metrics';
import { useEffect } from 'react';

/**
 * Adds the given values to the global metrics context while this component is mounted.
 * Null/undefined values are skipped. Context is removed on unmount to avoid leaks.
 *
 * Matches Mixpanel context add/remove pattern.
 */
export function useMetricsContext(patch: Partial<ContextData>) {
  // Only triggers when patch values actually change.
  const serialized = JSON.stringify(patch);
  useEffect(() => {
    const defined = Object.fromEntries(
      Object.entries(patch).filter(([, value]) => value != null)
    ) as Partial<ContextData>;
    const keys = Object.keys(defined) as Array<keyof ContextData>;
    if (!keys.length) return;
    metrics.appendContext(defined);
    return () => metrics.removeContext(keys);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serialized]);
}
